module.exports = __webpack_public_path__ + "mobile/img/sale-bannar1.72edb772.png";